import { defineComponent as _defineComponent } from 'vue'
import ContentTileViewModel = Vertica.LouisPoulsen.Application.Content.Blocks.ContentTileViewModel;
import userAgent from '@/services/userAgent.service';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentTile',
  props: {
    model: null
  },
  setup(__props: any) {

const props = __props as {model?: ContentTileViewModel}



const runImageAnimations = ref<boolean>(userAgent.isPrerender);
const inView = ref<boolean>(userAgent.isPrerender);
const imageReady = ref<boolean>(false);
const hasImageError = ref<boolean>(false);
const showSpinner = ref<boolean>(false);
const initOverlayAnimations = ref<boolean>(userAgent.isPrerender);

const hasImage = computed<boolean>(() => {
    return !!props.model.imageUrl;
});

function setInView(): void {
    inView.value = true;
    if (!hasImage.value) {
        // Animate the "no-image" if the product does not have an image
        runImageAnimations.value = true;
    }
    delayPreloadSpinner();
}

function imageLoaded() {
    imageReady.value = true;
    hasImageError.value = false;
    if (inView.value) {
        initAnimations();
    }
}

function imageLoadError() {
    imageReady.value = true;
    hasImageError.value = true;

    if (inView.value) {
        initAnimations();
    }
}

function initAnimations() {
    runImageAnimations.value = true;
}

function delayPreloadSpinner() {
    setTimeout(() => {
        showSpinner.value = true; // Delay show spinner if images hasn't loaded after 300ms
    }, 300);
}

return { __sfc: true,props, runImageAnimations, inView, imageReady, hasImageError, showSpinner, initOverlayAnimations, hasImage, setInView, imageLoaded, imageLoadError, initAnimations, delayPreloadSpinner }
}

})